'use strict';

angular.module('ntmApp').factory('ListGridFiter', ['$templateRequest', 'uiGridConstants', 'Utils',
    function ($templateRequest, uiGridConstants, Utils) {

        function ListGridFiter() {

        var self = this;
        var dateFilterTmpl = $templateRequest('ng1/src/listGrid/objects/filters/views/grid-filter-datepicker.html');

        self.filterOptions = [];
        self.filterSelectedOptions = [];

        self.buidFilter = function (column, cell, grid) {

            switch (column.filterType) {
                case 'TEXT':
                    builtTextFilter(cell);
                    break;
                case 'NUMBER':
                    builtNumberFilter(cell);
                    break;
                case 'DATE':
                    builtDateFilter(cell);
                    break;
                case 'TIME':
                    builtTimeFilter(cell, column);
                    break;
                case 'CHECKBOX':
                    builtCheckboxFilter(cell);
                    break;
                case 'CHECKLIST':
                    builtMultiselectFilter(cell, column, grid);
                    break;
                case 'RADIOBOOLEAN':
                    builtRadioBooleanFilter(cell);
                    break;
                default:
                    builtTextFilter(cell);
            }
        };

        self.toggleFilterDisabling = function (disable) {
            $(".ui-grid-header-cell-wrapper input").prop("disabled", disable);
            $(".ui-grid-header-cell-wrapper select").prop("disabled", disable);
            $(".ui-grid-header-cell-wrapper button").prop("disabled", disable);
        };

        //private methods

        function builtTextFilter(cell) {
            cell.filter = {
                type: uiGridConstants.filter.INPUT,
                placeholder: 'Search'
            };
        }

        function builtNumberFilter(cell) {
            cell.filterHeaderTemplate = '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><input type="number" placeholder="Search" ng-model="colFilter.term" name="number" class="ui-grid-filter-input"></div>';
            cell.cellFilter = 'number';           
        }

        function builtDateFilter(cell) {

            cell.cellFilter = 'date:"MM/dd/yyyy"';
            cell.filterHeaderTemplate = dateFilterTmpl;
            cell.filters = [
                  {
                      label: 'from:',
                      condition: function (term, value) {
                          if (!term) {
                              return true;
                          }

                          if (!value) {
                              return false;
                          }

                          var valueDate = new Date(value);
                          return valueDate >= term;
                      }
                  },
                  {
                      label: 'to:',
                      condition: function (term, value) {
                          if (!term) {
                              return true;
                          }

                          if (!value) {
                              return false;
                          }

                          var valueDate = new Date(value);
                          return valueDate <= term;
                      }
                  }];
        }

        function builtTimeFilter(cell, column) {
            cell.filter = {
                applyFilter: column.applyFilter,
                fieldName: column.fieldName,
                placeholder: 'Search',
                condition: function (term, value) {
                    var timeString = moment(value).format('h:mm a').toLowerCase();
                    if (timeString.indexOf(term.toLowerCase()) !== -1) {
                        return true;
                    } else {
                        return false;
                    }
                }
            };
        }

        function builtMultiselectFilter(cell, column, grid) {

            var options = [];

            cell.filterHeaderTemplate = '<grid-multiselect></grid-multiselect>';

            cell.filter = {
                filterFieldName: column.fieldName,
                filterSelectedOptions: [],
                filterOptions: [{ id: null, value: 'Blank' }]
            };

            grid.forEach(function (item) {
                if (!Utils.IsNullOrEmpty(item[column.name]) && !options.includes(item[column.name])) {
                    options.push(item[column.name]);
                    //TODO: change to { id: item[column.fieldName], value: item[column.name + '_'] }
                    cell.filter.filterOptions.push({ id: item[column.name], value: item[column.name] });
                }
            });
        }

        function builtCheckboxFilter(cell) {
            cell.filter = {
                type: uiGridConstants.filter.SELECT,
                selectOptions: [
                  { value: true, label: 'Checked' },
                  { value: false, label: 'Unchecked' }
                ]
            };
        }

        function builtRadioBooleanFilter(cell) {
            cell.filter = {
                type: uiGridConstants.filter.SELECT,
                selectOptions: [
                  { value: 'Yes', label: 'Yes' },
                  { value: 'No', label: 'No' },
                  { value: 'Empty', label: 'Empty' }
                ],
                condition: function (term, value) {
                    if (term === 'Empty') {
                        return !value;
                    }
                    return term === value;
                }
            };
        }

    }

        return (ListGridFiter);
}]);